import Sidebar from 'components/common/sidebar'
import Navbar from 'components/common/navbar'
import Box from 'components/common/box'
import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { useTourComponentRefs } from 'context/TourRefsProvider'
import { physicianSidebarUtils } from 'utils/sidebarUtils/physicianSidebarUtils'
import { useTranslation } from 'react-i18next'
import { synappAdminSidebarUtils } from 'utils/sidebarUtils/synappAdminSidebarUtils'
import { roles } from '../../../constants'
import { useUserDetails } from 'context/UserDetailsProvider'
import { patientSidebarUtils } from 'utils/sidebarUtils/patientSidebarUtils'
import { authorEditorSidebarUtils } from 'utils/sidebarUtils/authorEditorSidebarUtils'
import NetworkErrorDetection from 'components/common/network-error-detection'
import './MainLayout.scss'

const MainLayout = () => {
  /* translation dependencies */
  const { t } = useTranslation()
  /* translation dependencies */

  /* sidebar collapsed dependencies */
  const [collapsed, setCollapsed] = useState(false)
  /* sidebar collapsed dependencies */

  /* tour routes */
  const ref = useTourComponentRefs()
  /* tour routes */

  /* sidebar dependencies */
  const { selectedRole, userDetails } = useUserDetails()
  const renderRoleBasedSidebarUtil = {
    [roles.superAdmin]: synappAdminSidebarUtils(t),
    [roles.patient]: patientSidebarUtils(
      t,
      ref?.ref2,
      ref?.ref3,
      ref?.ref4,
      ref?.ref5,
      userDetails?.permissions?.admin_permissions
    ),
    [roles.physician]: physicianSidebarUtils(
      t,
      ref?.ref2,
      ref?.ref3,
      ref?.ref4,
      ref?.ref5,
      ref?.ref6,
      userDetails?.permissions?.admin_permissions
    ),
    [roles.hcp]: physicianSidebarUtils(
      t,
      ref?.ref2,
      ref?.ref3,
      ref?.ref4,
      ref?.ref5,
      ref?.ref6,
      userDetails?.permissions?.admin_permissions
    ),
    [roles.editor]: authorEditorSidebarUtils(t, userDetails?.permissions?.admin_permissions),
    [roles.author]: authorEditorSidebarUtils(t, userDetails?.permissions?.admin_permissions)
  }
  const menuGroup = renderRoleBasedSidebarUtil[selectedRole]
  /* sidebar dependencies */

  return (
    <div className="main-layout-container">
      <div className="sidebar-layout-container">
        <Sidebar
          collapsed={collapsed}
          menuGroup={menuGroup}
          onToggleCollapsed={() => setCollapsed((prev) => !prev)}
        />
      </div>

      <div
        className={`main-layout-wrapper ${collapsed ? 'main-layout-wrapper-expand' : 'main-layout-wrapper-collapse'}`}
      >
        <Navbar sidebarCollapsed={collapsed} setSidebarCollapsed={setCollapsed} />
        <NetworkErrorDetection />
        <div className="outlet-container">
          <Box>
            <Outlet />
          </Box>
        </div>
      </div>
    </div>
  )
}

export default MainLayout
